import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

import {
    MARK_WAVE_PATH,
    WORDMARK_PATHS,
    WORDMARK_STROKE,
    WORDMARK_VIEWBOX
} from '@/constants/brand'

interface LogoProps {
    className?: string
    showWordmark?: boolean
}

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            aria-hidden='true'
            className={cn('size-6', className)}
        >
            <circle cx='12' cy='12' r='10.6' strokeWidth='2.8' />
            <path d={MARK_WAVE_PATH} strokeWidth='2.6' strokeLinecap='round' />
        </svg>
    )
}

export const Wordmark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    const [width, height] = WORDMARK_VIEWBOX

    return (
        <svg
            viewBox={`0 0 ${width} ${height}`}
            fill='none'
            stroke='currentColor'
            strokeWidth={WORDMARK_STROKE}
            aria-hidden='true'
            className={cn('h-5 w-auto', className)}
        >
            {WORDMARK_PATHS.map(path => (
                <path key={path} d={path} />
            ))}
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, showWordmark = true }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5 text-ink', className)}>
            <LogoMark className='size-[26px]' />
            {showWordmark && <Wordmark className='h-[19px]' />}
            <span className='sr-only'>Onda</span>
        </span>
    )
}
